export const QA_NAME_LISTING_PROFILE_INFO_AVAILABLE_FROM =
  'listingInfoAvailableFrom'

export const QA_NAME_LISTING_PROFILE_INFO_RENT = 'listingInfoRent'

export const QA_NAME_LISTING_PROFILE_INFO_RESPONSIBLE_MANAGER =
  'listingInfoResponsibleManager'

export const QA_NAME_LISTING_PROFILE_INFO_RESPONSIBLE_MANAGER_ADD =
  'listingInfoResponsibleManagerAddBtn'

export const QA_NAME_LISTING_PROFILE_INFO_RESPONSIBLE_MANAGER_EDIT =
  'listingInfoResponsibleManagerEditBtn'

export const QA_NAME_LISTING_PROFILE_PHASE_BAR = 'listingPhaseBar'

export const LISTING_PROFILE_HEADER_INFO_ITEMS_COLUMNS = 3

export const LISTING_PROFILE_HEADER_INFO_ITEMS_LOADING_LENGTH = 3

export const LISTING_PROFILE_INFO_ITEM_ACTION_KEY = {
  add: 'add',
  edit: 'edit',
}

export const LISTING_PROFILE_INFO_ITEM_TITLE_KEY = {
  availableFrom: 'RentalPortal.ListingAvailableFromColumnKey',
  rent: 'RentalPortal.ListingRentColumnKey',
  responsibleManager: 'RentalPortal.ListingProfileResponsibleManagerKey',
}

export const LISTING_TERMINAL_PHASE_KEY = {
  closed: 'closed',
  deactivated: 'deactivated',
}

export const LISTING_PHASE_TERMINAL_STATEMENT_KEY = {
  [LISTING_TERMINAL_PHASE_KEY.closed]:
    'RentalPortal.ListingPhaseTerminalClosedKey',
  [LISTING_TERMINAL_PHASE_KEY.deactivated]:
    'RentalPortal.ListingPhaseTerminalDeactivatedKey',
}

export const LISTING_AVAILABLE_FROM_SOON_DAYS = 7

export const LISTING_AVAILABLE_FROM_TEXT_COLOR = {
  future: 'var(--color-success)',
  inactive: 'var(--secondary-text-color)',
  past: 'var(--color-error)',
  soon: 'var(--color-warning)',
}
